module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "mobile-listing"
  }, [_c('div', {
    staticClass: "container contentpages"
  }, [_c('div', {
    staticClass: "mobile-section-title"
  }, [_vm._v("Phone Cases")]), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Loader')], 1) : (_vm.pcovers && _vm.pcovers_sorted) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "sdata"
  }, _vm._l((Math.ceil(_vm.pcovers_sorted.length / _vm.logoPerRow)), function(index) {
    return _c('div', {
      key: index,
      staticClass: "text-center"
    }, [_vm._l((_vm.pcovers_sorted.slice(_vm.logoPerRow * (index - 1) + 1 - 1, _vm.logoPerRow * (index - 1) + _vm.logoPerRow)), function(item, key) {
      return _c('div', {
        key: key,
        staticClass: "disInline"
      }, [(item.cnt !== 0) ? _c('div', [_c('div', {
        staticClass: "m-1 grow shadow-4 mobile-logo brand-cover",
        class: (_vm.selectedBrand === _vm.logoPerRow * (index - 1) + key) && '_active',
        domProps: {
          "innerHTML": _vm._s(_vm.MOBILE_LOGO[item.category.toLowerCase()])
        },
        on: {
          "click": function($event) {
            _vm.toggleListing($event, _vm.logoPerRow * (index - 1) + key)
          }
        }
      })]) : _vm._e()])
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('div', {
      staticClass: "tooltips",
      class: (_vm.isSelected && _vm.selectedBrand >= _vm.logoPerRow * (index - 1) + 1 - 1 && _vm.selectedBrand < _vm.logoPerRow * (index - 1) + _vm.logoPerRow) ? '_show' : ''
    }, [_c('div', {
      staticClass: "bottom"
    }, [(_vm.selectedBrand !== '') ? _c('mobile-list', {
      attrs: {
        "mobileList": _vm.pcovers_sorted[_vm.selectedBrand]
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "arrow"
    })], 1)])])], 2)
  }))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e6f9f84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-covers.vue
// module id = 2454
// module chunks = 71